import { useEffect } from "react";

/**
 * Paints the create-project wizard's grey page background.
 *
 * Sets only the `background` property and puts back whatever was there before.
 * These screens used to do `document.body.setAttribute("style", "background:
 * #eee")`, which replaces the entire attribute. Under release.react-nav that
 * destroyed the inline `margin: 0; padding: 0; overflow: hidden` that
 * layouts/project.html.haml sets on <body>, leaving the wizard offset from the
 * fixed nav chrome and scrolling twice (ProjectLayout's content div is already
 * `height: 100vh; overflow-y: auto`). Nothing ever put the grey back, either,
 * so it leaked onto every later page in the same SPA session.
 *
 * Restoring the previous value rather than clearing it keeps nesting correct:
 * these screens mount inside one another (NewProjectDetails -> Services ->
 * AddByBlueprint), and effect cleanup runs innermost-first.
 */
const useGreyBodyBackground = (enabled = true): void => {
  useEffect(() => {
    if (!enabled) return undefined;

    const previousBackground = document.body.style.background;
    document.body.style.background = "#eee";

    return () => {
      document.body.style.background = previousBackground;
    };
  }, [enabled]);
};

export default useGreyBodyBackground;
